module.exports = __webpack_public_path__ + "static/media/Sample_Proofreading_and_formattingAfter.374561fd.png";